export default __webpack_public_path__ + "static/media/Bret.f6228261.png";